module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-tasks-dark-e43626208cb844cae8dbe35d828a43b3.svg";